module.exports = __webpack_public_path__ + "img/hero.000112fb.webp";